import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'input',
	]

	static values = {
		paramName: String,
	}

	getName() {
		if (this.hasParamNameValue) {
			return this.paramNameValue
		} else {
			return this.inputTarget.name
		}
	}

	getValue() {
		if (this.inputTarget.type == 'checkbox' && !this.inputTarget.checked) {
			return null
		} else {
			return this.inputTarget.value
		}
	}

}
